<template>
  <div class="flex h-screen bg-gray-100 dark:bg-gray-900">
    <!-- Sidebar -->
    <AppSidebar />

    <!-- Main Content -->
    <div class="flex-1 flex flex-col overflow-hidden">
      <!-- Topbar -->
      <AppTopbar />

      <!-- Page Content -->
      <main class="flex-1 overflow-auto bg-gray-50 dark:bg-gray-800">
        <div class="container mx-auto px-4 py-6 sm:px-6 lg:px-8">
          <!-- Breadcrumb -->
          <AppBreadcrumb class="mb-6" />

          <!-- Page Content -->
          <slot></slot>
        </div>
      </main>
    </div>

    <!-- Doğum günü / iş yıl dönümü görseli (o gün ilk açılışta, bir kez) -->
    <CelebrationModal />
  </div>
</template>

<script setup lang="ts">
import AppSidebar from '@/components/common/AppSidebar.vue'
import AppTopbar from '@/components/common/AppTopbar.vue'
import AppBreadcrumb from '@/components/common/AppBreadcrumb.vue'
import CelebrationModal from '@/components/common/CelebrationModal.vue'
</script>
